import React, { useEffect } from "react";
import { FormElements } from "../../../../../../../../shared/bootstrap/form/FormElements";
import { useLanguageForShared } from "../../../../../../../../shared/utils/languages/useLanguageForShared";
import { useEffectOnlyUpdate } from "../../../../../../../../shared/utils/use_custom/useEffectCustom";
import { copyObject } from "../../../../../../../../shared/utils/objUtils";
import { useTemplateFormOtherInfo } from "../../data/useTemplateFormOtherInfo";
import { useParamsData } from "../../data/useParamsData";

const ConcentratorCoreOtherInfo = ({ dataForm, changeValue, errors, setData, isSubmit }) => {
  const { t } = useLanguageForShared();
  const {
    formStructureCannulaNasal,
    formStructureMask,
    formStructureDetailCannulaNasal,
    formStructureDetailMask
  } = useTemplateFormOtherInfo(t, dataForm);
  const {
    formStructureNote
  } = useParamsData(t, dataForm);

  useEffectOnlyUpdate(() => {
    if (!dataForm?.cannulaNasal) {
      const modeField = formStructureDetailCannulaNasal.map((ele) => ele.name).join(",").split(",");
      const copyDataForm = copyObject(dataForm);
      modeField?.forEach((key) => {
        delete copyDataForm[key];
      });
      setData(copyDataForm);
    }
  }, [dataForm?.cannulaNasal]);

  useEffect(() => {
    if (!dataForm?.mask) {
      const modeField = formStructureDetailMask.map((ele) => ele.name).join(",").split(",");
      const copyDataForm = copyObject(dataForm);
      modeField?.forEach((key) => {
        delete copyDataForm[key];
      });
      setData(copyDataForm);
    }
  }, [dataForm?.mask]);

  return (
    <>
      <p className={"title-paragraph"} style={{ fontWeight: "bold", marginBottom: "1.5rem", marginTop: "2rem" }}>{t("sg.otherInfo")}</p>
      <FormElements
        structure={formStructureCannulaNasal}
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />
      <FormElements
        structure={formStructureMask}
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />
      <FormElements
        structure={formStructureNote}
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />
    </>
  );
};

export default ConcentratorCoreOtherInfo;
